export default __webpack_public_path__ + "static/media/Vegas_City_C01.a8f70e00.mp4";